import type { ActionContext } from 'vuex'
import type { ActionClass, Sort, ToolingState } from '../../../models'
import { TOOLING_CONSTS } from '../tooling.consts'

export class SetSortingAction implements ActionClass {
  static execute(
    this: void,
    { commit }: ActionContext<ToolingState, unknown>,
    { tool, sort }: { tool: string; sort: Sort },
  ): void {
    commit(TOOLING_CONSTS.mutations.setState, { [tool]: { sort } })
  }
}
